export const workData = [
    {
        id: 1,
        title: 'Boring Stories',
        prevImg: 'prev_boringStories.png',
        categories: 'Website design  ||  Frontend  ||  Backend',
        description: "Boring Stories website is a photographer's blog. Boasts a clean and simple design, letting the stories take center stage. No distractions, just the pure joy of storytelling.",
        links: [
            {
                id: 1,
                title: 'Demo',
                link: 'https://boring-stories.netlify.app/'
            },
            {
                id: 2,
                title: 'GitHub repo',
                link: 'https://github.com/DagnaSchmidt/boring-stories'
            },
            {
                id: 3,
                title: 'UI design',
                link: 'https://dribbble.com/shots/23010524-Boring-Stories-UI'
            },
        ],
        buildOn: [
            {
                id: 1,
                title: 'UI',
                stack: ['Figma']
            },
            {
                id: 2,
                title: 'Frontend',
                stack: ['React', 'Redux', 'Axios', 'Tailwind', 'Framer Motion']
            },
            {
                id: 3,
                title: 'Backend',
                stack: ['REST API', 'Express', 'MongoDB']
            }
        ]
    },
    {
        id: 2,
        title: 'Mi',
        prevImg: 'prev_mi.png',
        categories: 'App design  ||  UX / UI  ||  Design System',
        description: "Recognizing the diverse needs of users in balancing work, personal life, and health, this project aims to create a calendar application that seamlessly integrates functionality, style, and personalization.",
        links: [],
        buildOn: [
            {
                id: 1,
                title: 'UI',
                stack: ['Figma']
            }
        ]
    },
    {
        id: 3,
        title: 'Movies4you',
        prevImg: 'prev_movies4you.png',
        categories: 'App design  ||  UI  ||  Design System || Frontend || Backend',
        description: "Explore the world of cinema like never before with Movies4You, a stunning mobile app that redefines your movie-watching experience. Navigate effortlessly through a seamless design crafted for a delightful user experience.",
        links: [
            {
                id: 1,
                title: 'UI Prototype',
                link: 'https://www.figma.com/proto/exTv5ZsK0UDgOrQSmRAyQq/1.-M4y?page-id=10%3A2&node-id=152%3A5730&viewport=475%2C-1315%2C0.29&scaling=contain&starting-point-node-id=10%3A18'
            },
            {
                id: 2,
                title: 'UI design',
                link: 'https://dribbble.com/shots/23009539-Movies4you-UI'
            },
            {
                id: 3,
                title: 'Demo',
                link: 'https://movies-dagnas-projects.vercel.app/'
            },
            {
                id: 4,
                title: 'GitHub repo',
                link: 'https://github.com/DagnaSchmidt/movies'
            }
        ],
        buildOn: [
            {
                id: 1,
                title: 'UI',
                stack: ['Figma']
            },
            {
                id: 2,
                title: 'Frontend',
                stack: ['React', 'Next.js', 'TypeScript', 'Axios', 'Tailwind']
            },
            {
                id: 3,
                title: 'Backend',
                stack: ['REST API', 'MongoDB']
            }
        ]
    },
    {
        id: 4,
        title: 'Finovo',
        prevImg: 'prev_finovo.png',
        categories: 'App design  ||  UI',
        description: "Take control of your financial destiny with Finovo, a revolutionary finance app designed to simplify and elevate your money management experience. Finovo isn't just a finance app; it's a financial ally that puts the power of financial well-being in your hands.",
        links: [
            {
                id: 1,
                title: 'UI design',
                link: 'https://dribbble.com/shots/23028556-Finovo-Finance-App-UI'
            }
        ],
        buildOn: [
            {
                id: 1,
                title: 'UI',
                stack: ['Figma']
            }
        ]
    },
    {
        id: 5,
        title: 'Maja Penzion',
        prevImg: 'prev_maja.png',
        categories: 'Website design  ||  Frontend  ||  Logo Design',
        description: "Penzion Maja is Polish guesthouse in the Czech Karkonosze Mountains. Discover the charm of the Czech Karkonosze Mountains by staying at the Mája Pension - a place where silence and nature create ideal conditions for relaxation and regeneration.",
        links: [
            {
                id: 1,
                title: 'Demo',
                link: 'https://penzionmaja.com/'
            }
        ],
        buildOn: [
            {
                id: 1,
                title: 'UI',
                stack: ['Figma']
            },
            {
                id: 2,
                title: 'Frontend',
                stack: ['WordPress']
            }
        ]
    }
];
